(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 23795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/linkClasses.js


function getLinkUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiLink', slot);
}
const linkClasses = (0,generateUtilityClasses/* default */.Z)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
/* harmony default export */ var Link_linkClasses = (linkClasses);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/getTextDecoration.js


const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}Channel`);
  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }
  return (0,colorManipulator/* alpha */.Fq)(color, 0.4);
};
/* harmony default export */ var Link_getTextDecoration = (getTextDecoration);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/Link.js
'use client';



const _excluded = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];














const useUtilityClasses = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0,capitalize/* default */.Z)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};
const LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0,capitalize/* default */.Z)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0,esm_extends/* default */.Z)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: Link_getTextDecoration({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${Link_linkClasses.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/react.forwardRef(function Link(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiLink'
  });
  const {
      className,
      color = 'primary',
      component = 'a',
      onBlur,
      onFocus,
      TypographyClasses,
      underline = 'always',
      variant = 'inherit',
      sx
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  const handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleFocus = event => {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
    color: color,
    className: (0,clsx/* default */.Z)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

/***/ }),

/***/ 64358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx
var Footer = __webpack_require__(91001);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./src/components/index.ts + 105 modules
var components = __webpack_require__(67455);
// EXTERNAL MODULE: ./src/pages/Login/Login.styles.ts
var Login_styles = __webpack_require__(49617);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/utils/regex.tsx
var regex = __webpack_require__(37001);
// EXTERNAL MODULE: ./src/components/Register/BasicInfo/BasicInfo.styles.ts
var BasicInfo_styles = __webpack_require__(71743);
// EXTERNAL MODULE: ./src/pages/Register/Register.styles.ts
var Register_styles = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx
var AuthContext = __webpack_require__(82030);
// EXTERNAL MODULE: ./src/utils/string-utils.tsx
var string_utils = __webpack_require__(46955);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Login/LoginForm/LoginForm.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M447.23 284.71c21.71 6.21 37.49 23.62 42.22 45.57q1.31 6.08 1.31 16.56-.02 44.58-.01 89.2c0 5.92-2.19 8.19-7.94 8.2l-12.03.02c-5.81 0-8.79-1.75-8.78-7.74q.02-45.08-.01-90.17-.01-8.28-1.38-12.52c-9.53-29.38-55.33-30.85-64.84-1.04q-1.31 4.12-1.3 11.55.1 45.61.02 91.2c-.01 5.5-1.65 8.65-7.4 8.69q-7.68.05-15.34 0c-4.46-.03-6-3.77-6-7.89V227.7c0-4.32 1.67-7.78 6.25-7.88q11.53-.26 16.01.01c5.25.31 6.47 4 6.48 8.83q.04 26.72 0 53.42c-.01 7.74 5.65 9.78 12.15 6.73 14.02-6.58 25.59-8.4 40.59-4.1zm378.75 18.13-5.05-75.62a.44.44 0 0 1 .44-.47h26.9a.44.44 0 0 1 .44.47l-5.35 75.62a.44.44 0 0 1-.44.41h-16.5a.44.44 0 0 1-.44-.41zM273.99 415.2c13.69 8.64 32.56-.23 33.75-17.08.39-5.58 1.95-8.04 7.62-8.09q6.4-.07 12.81-.02c10.81.08 8.92 9.29 7.07 17.21q-4.28 18.35-18.17 29.29c-20.83 16.4-50.34 13.9-68.44-5.24q-13.9-14.69-13.89-36.27.02-38.51.01-76.5a2.74 2.74 0 0 0-2.74-2.74q-15.49-.02-30.98-.01c-4.27.01-7.23-1.91-7.26-6.33q-.04-7.33-.02-14.66c.02-5.17 2.16-7.72 7.28-7.74q15.94-.04 31.24-.01a2.48 2.48 0 0 0 2.48-2.48q.01-24.15 0-49.03c0-5.33 3.48-7 8.46-7q6.23-.01 12.44.01c4.65.02 8.1 1.82 8.1 6.74v49.26a2.49 2.49 0 0 0 2.49 2.49h51.26c4.38 0 6.22 3.48 6.23 7.64q.02 6.76.03 13.5c.01 4.47-1.69 7.61-6.42 7.6q-25.53 0-50.77.02a2.82 2.81 0 0 0-2.82 2.81v76.18c.01 8.87 2.83 15.78 10.24 20.45zm457.47-129.04.55.46q.47.38 1.07.38 24.56 0 49.1.01c6.13 0 8.73 1.87 8.79 8 .08 6.91 1.37 16.82-2.69 19.61q-1.66 1.13-5.31 1.13H733.7a2.96 2.96 0 0 0-2.96 2.96q.03 37.06-.01 74.74 0 6.72 1.31 10.42c5.85 16.45 26.76 19.89 37.83 6.31q4.44-5.45 4.93-14.17c.29-5.02 4.58-5.98 9.07-6q6.69-.03 13.38 0c4.34.02 6.27 3.52 6.27 7.64-.01 15.79-8.46 30.97-20.77 39.9-29.5 21.43-70.79 6.01-79.39-29.08q-1.35-5.52-1.36-15.54v-74.02a3.15 3.15 0 0 0-3.14-3.15q-15.87-.04-32.11.01c-4.33.01-5.94-3.6-5.98-7.62q-.06-6.55-.01-13.11c.04-4.4 1.79-8.06 6.49-8.05q16.26.02 31.88 0a2.85 2.85 0 0 0 2.84-2.85q.03-24.3.04-48.24c0-4.81 2.13-7.38 6.92-7.39q7-.02 13.99-.01c5.43 0 7.81 2.32 7.82 7.59q.02 24.34 0 48.55a1.97 1.96 19.7 0 0 .72 1.52zm-118.21 62.16c5.09.04 3.5-8.85 3.52-12.07q.08-20.15-18.83-25.14c-9.67-2.56-26.42-1.63-34.46 5.05q-5.26 4.38-5.49 12.59-.12 4.13-5 4.3-6.65.22-13.3.19c-5.1-.03-9.47.41-9.88-5.48q-.63-9.15 4.3-18.9c7.77-15.36 27.35-24.06 44.01-26.03 27.61-3.28 59.28 6.97 66.02 37.51q1.29 5.86 1.32 19.92.09 47.8.02 95.61c-.01 5.39-1.83 8.29-7.35 8.36q-7.39.1-10.38.01c-6.37-.2-5.89-12.33-13.27-8.07-8.8 5.08-15.36 9.39-26.48 10.67-15.23 1.75-32.09-.94-44.71-9.4-26.55-17.78-28.2-60.42-2.06-79.28q8.72-6.29 19.61-8.58 5.86-1.23 19.91-1.3 16.25-.09 32.5.04zm-19.37 71.34q19.83-3.46 24.27-21.47c1.49-6.07 1.23-14.18 1.06-20.9a2.85 2.84 89.3 0 0-2.84-2.78q-20.92-.04-41.97.02c-10.5.02-19.79 4.17-22.33 15.24-2.82 12.3 1.81 24.93 14.44 29.17 8.27 2.78 19.14 2.15 27.37.72zm340.75-136.78c24.27 2.93 46.98 19.2 47.65 45.53.14 5.39-2.03 8.03-7.38 8.07q-6.29.05-12.58.02c-4.38-.03-8.5-1.18-8.78-6q-.37-6.63-2.79-10.34-4.46-6.82-12.39-8.99c-12.68-3.46-33.42-2.63-39.44 12.07q-3.6 8.77 4.14 15.18c5.09 4.2 13.7 5.93 20.97 7.15 30.66 5.11 65.02 12.39 64.33 52.05-.91 52.21-72.46 61.2-105.63 37.21-13.4-9.69-20.66-27-19.73-43.09.25-4.37 3.77-5.72 7.85-5.73q6.47-.03 12.95.01c4.21.02 8 1.7 7.99 6.23-.02 25.31 22.62 28.75 42.21 27.28 13.97-1.05 26.73-8.39 25.59-24.29-2.21-30.83-83.92-9.29-90.88-60.74-5.08-37.49 35.16-55.34 65.92-51.62zM460.57 605.39c-9.44-29.3-55.17-30.67-64.82-.95q-1.28 3.95-1.27 10.75.08 47.29.01 94.56c-.01 4.36-3.82 6-7.88 6q-6.58-.01-13.13.01c-5.11.02-7.73-1.85-7.73-7.02q0-104.85.01-209.71c0-3.78 1.73-7.47 5.73-7.5q7.45-.06 14.89-.02c5.44.04 8.09 2.19 8.1 7.61q.06 27.61.01 55.22c-.01 6.44 5.51 9.26 11.28 6.59 9.63-4.45 17.25-7.42 27.48-6.86 27.38 1.48 50.08 20.27 56.07 47.07q1.4 6.25 1.41 18.33.05 44.5 0 89c0 4.21-1.92 7.26-6.31 7.27l-14.71.02c-4.98.01-7.7-1.98-7.7-7.01q-.02-44.49-.01-88.98.01-9.91-1.43-14.38z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: "-16",
      y: "-16.13",
      transform: "rotate(.115 -290264.664 564080.533)",
      width: "32",
      height: "32.26",
      rx: "5.22"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M1266.16 608.54q.49.97 1.4.71.36-.11.82-.52 26.39-24.28 52.76-48.59c2.35-2.17 4.63-2.86 8.03-2.87q8.92-.03 17.84-.03c4.08.01 6.69 4.69 5.47 8.37q-.51 1.55-2.99 3.87-32.02 30.08-63.42 59.72-3.7 3.49-.03 7.02 35.98 34.51 72.31 69.43c2.89 2.78 1.09 7.58-2.01 9.27q-1.55.84-5.32.84-8.98 0-17.97-.03c-3.92-.02-6.55-1.26-9.21-3.82q-26.86-25.89-53.65-51.86-1.22-1.19-2.36-1.83a1.23 1.23 0 0 0-1.83 1.07q-.01 24.84 0 49.96c0 4.53-3.04 6.45-7.42 6.48q-6.99.04-13.98.02c-4.53-.01-7.34-2.04-7.34-6.65q-.01-104.57-.01-209.14c0-5.87 1.8-8.41 7.7-8.44q7.27-.03 14.56-.04c4.85 0 6.48 3.89 6.48 8.36q.02 53.93.01 108a1.62 1.59-58.5 0 0 .16.7zM234.72 556.31q.1-24.09.01-48.81-.02-7.1 7.26-7.3 6.45-.17 12.89-.18c6.23 0 8.84 2.1 8.85 8.29q.04 23.85.01 47.66a2.79 2.79 0 0 0 2.79 2.79q24.8-.02 49.86.01c4.51 0 7.36 2.01 7.36 6.62q-.01 6.87.01 13.71c.02 5.64-1.65 8.38-7.42 8.39q-25.16.03-50.1.01a2.48 2.48 0 0 0-2.49 2.48q0 37.04-.01 74.7 0 7.52 1.23 10.99c5.71 16.07 26.55 19.59 37.46 6.77q4.97-5.84 5.35-14.69c.2-4.65 3.87-5.99 8.16-5.99l14.31-.02c5.17-.01 6.43 4.38 6.23 8.9-1.06 23.13-17.98 42.57-40.23 47.35-32.47 6.96-61.51-18.38-61.5-50.99q.01-38.87 0-77.01a2.48 2.48 0 0 0-2.48-2.48q-16.02-.03-32.52 0c-4.68.01-6-4.01-6.01-8.22q-.01-6.54.03-13.08c.04-5.11 2.23-7.47 7.23-7.46q15.75.02 31.28-.01a2.44 2.44 0 0 0 2.44-2.43zm658.32 129.73q-6.53 16.64-20.92 25.46c-29.42 18.02-68.14 2-75.99-31.29q-1.39-5.91-1.39-17.53.02-36.2.01-72.23a2.95 2.95 0 0 0-2.95-2.95q-14.66-.01-29.91 0c-5.54 0-8.37-1.68-8.38-7.39q-.02-6.65 0-13.28c.01-5.42 1.84-8.07 7.33-8.07q15.79-.01 30.96-.01a2.96 2.95-89.9 0 0 2.95-2.95q.01-23.74-.01-47.67c0-5.66 2.12-8.03 7.66-8.1q6.11-.07 12.23-.02c6.35.06 8.87 1.97 8.87 8.31v47.73a2.7 2.7 0 0 0 2.7 2.7q24.5.01 49.41 0c5.53 0 8.05 2.18 8.11 7.62q.08 6.34.01 12.68c-.05 5.64-1.91 8.44-7.66 8.44q-25.03.03-49.87.01a2.69 2.69 0 0 0-2.7 2.69v73.52q0 8.52 1.44 12.37c4.01 10.7 15.87 16.66 26.95 13.18q12.06-3.78 15.27-16.79c.98-3.95-.56-7.44 3.66-9.87 3.08-1.78 13.09-.86 16.96-.85q3.76 0 5.32.76c6.16 2.97 2.06 18.12-.06 23.53zm704.77-96.02a1.74 1.68 53.5 0 0-.06.45q-.01 36.62.01 73.3 0 8.43 1.45 12.26c4.13 10.9 16.3 16.86 27.54 13.07q11.22-3.79 14.67-16.22c1.07-3.87-.64-8.2 4.04-10.48q1.26-.61 3.7-.63 6.66-.05 13.33-.02c9.38.05 8.75 6.71 7.67 13.8-2.04 13.36-9.14 25.19-19.68 33.16-29.44 22.24-71.56 6.77-80.11-28.84q-1.36-5.71-1.37-16.35-.01-36.63 0-73.13a2.88 2.87-90 0 0-2.87-2.88q-14.74-.03-29.99 0c-5.43.01-8.32-1.85-8.37-7.4q-.06-7.68 0-15.36c.04-4.57 4.02-5.99 8.19-5.99q15.35-.01 30.16-.01a2.87 2.87 0 0 0 2.87-2.87q.03-23.29 0-47.12c-.01-5.87 1.75-8.68 7.74-8.73q7.26-.07 14.52-.02c5.08.04 6.49 4.01 6.5 8.62q.01 23.57 0 47.21a2.91 2.91 0 0 0 2.91 2.92q24.53-.02 49.65.01c4.89 0 7.57 2.04 7.65 6.94q.11 7.13 0 14.25c-.07 4.64-2.18 7.51-6.9 7.52q-24.82.05-49.64.01c-1.89 0-3.13.58-3.61 2.53zm-950.72 93.05c-6.26 16.07-19.81 27.49-36.13 32.53-36.66 11.34-75.66-5.49-85.56-44.34q-1.71-6.71-2.27-17.64-.94-18.36.15-37.62c2.6-45.81 42.98-70.96 86.18-59.23 23.5 6.37 38.1 24.16 41.65 47.84 1.46 9.77.95 22.47.87 33.49-.03 4.61-1.84 7.64-6.66 7.64q-45.03.02-90.07.01-3.27 0-3.33 3.24c-.37 20.37 8.11 37.85 30.07 40.9q13.47 1.87 24.44-3.48 10.78-5.27 15.18-17.55c1-2.8 3.96-3.81 6.96-3.83q7.44-.05 14.89-.03c3.75.01 6.95.98 6.78 5.25q-.22 5.31-3.15 12.82zm-91.4-62.69 65.76-.22a3.15 3.15 0 0 0 3.13-3.17v-1.02a34.57 33.33-.2 0 0-34.69-33.2l-2.92.01a34.57 33.33-.2 0 0-34.45 33.45v1.02a3.15 3.15 0 0 0 3.17 3.13zm556.25-62.46c37.25-12.69 84.39 5.95 84.89 50.31.06 5.34-3.67 6.3-8.35 6.28q-7.38-.02-14.71-.13c-4.83-.07-5.52-2.66-5.86-7.08-1.36-17.38-18.68-24.96-33.98-24.54-13.55.37-25.39 7.43-30.55 20.17q-2.35 5.8-2.96 17-.88 15.93-.07 31.87.66 12.85 3.25 19.02c6.21 14.81 22.04 21.12 37.78 19.15 13.26-1.66 25.63-10.51 26.32-25 .19-3.81 1.32-6.19 5.31-6.39q4.66-.22 15.16-.07c6.07.09 8.81 2.14 8.58 8.29-1.46 38.07-38.71 56.69-72.75 51.34-25.65-4.03-43.94-21.73-50.1-46.9q-1.62-6.6-2.27-18.12-1.28-22.5.64-42.37c2.24-23.13 17.33-45.22 39.67-52.83zm333.93 160.91c-37.6 2.4-67.62-22.04-70.12-60.09q-1.56-23.64-.17-44.49c1.98-29.65 22.3-53.91 51.92-59.13 40.03-7.05 75.8 15.67 76.63 58.63q.4 20.76.05 26.5c-.26 4.23-4.09 5.5-8 5.5H1407c-2.13 0-2.98 1.8-2.98 3.79q.01 9.43 2.03 15.98 7.34 23.88 32.71 24.9c13.32.54 27.61-5.04 33.56-17.68 2.29-4.86 2.24-7.7 8.87-7.73q7.42-.02 14.83-.01c4.83 0 7.03 2.09 6.24 6.89-4.72 28.63-28.73 45.18-56.39 46.94zm-38-98.46 65.86-.23a3.09 3.09 0 0 0 3.07-3.1v-1.13a34.56 33.26-.2 0 0-34.68-33.13l-2.92.01a34.56 33.26-.2 0 0-34.44 33.38v1.13a3.09 3.09 0 0 0 3.11 3.07zm-408.78 66.78c.71 1.2 1.87 1.6 3.29 1.6h38.05c5.45 0 7.99 1.87 8.04 7.33q.06 5.88.02 11.77c-.03 4.47-1.58 7.89-6.43 7.89q-57.9.02-115.79.01c-5.21 0-7.93-1.73-7.99-7.06q-.07-6.96-.03-13.95c.03-4.24 3.6-5.96 7.6-5.97q20.36-.04 40.61-.01a2.79 2.79 0 0 0 2.79-2.79v-98.95a2.78 2.77.1 0 0-2.77-2.77q-18.46-.01-37.01 0c-4.92.01-7.88-1.61-7.94-6.75q-.08-6.48-.01-12.96c.04-4.22 1.89-7.28 6.32-7.28q31.54-.02 63.07-.01c5.52.01 7.83 2.22 7.83 7.6q.02 60.56.01 121.05a2.48 2.46 30 0 0 .34 1.25zm63.17 218.78c-55.41-1.12-97.06-31.32-125.13-77.23q-3.84-6.27-4.39-9.94c-2-13.41 14.1-22.54 24.9-14.76q2.01 1.45 5.5 6.2c23.85 32.44 53.2 54.88 94.99 56.85q6.81.33 13.62.15c42.24-1.12 73.53-22.77 97.48-55.96q4.18-5.79 6.32-7.32c10.73-7.68 26.53 1.24 24.84 14.64q-.47 3.7-3.93 9.4c-13.22 21.74-30.4 41.8-51.76 55.69-24.98 16.24-52.67 22.89-82.44 22.28z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fontWeight: "700",
        fontSize: "122.5px",
        fontFamily: "Monospace",
        InkscapeFontSpecification: "'Monospace Bold'",
        fill: "#fff",
        strokeWidth: "13.125"
      },
      d: "M1537.917 842.137q0-10.467 3.47-21.174 2.571-7.895 7.954-17.585 3.888-6.939 5.743-8.494 1.854-1.615 4.127-1.615 2.632 0 4.426 1.794 1.794 1.795 1.794 4.307 0 1.735-1.435 4.127-6.46 10.587-9.45 19.859-2.932 9.27-2.932 18.781 0 9.57 2.931 18.842 2.991 9.271 9.451 19.858 1.435 2.333 1.435 4.127 0 2.513-1.794 4.307-1.794 1.795-4.426 1.795-2.213 0-3.888-1.436-2.393-2.094-6.34-9.39-5.683-10.588-7.776-17.467-3.29-10.527-3.29-20.636zm62.446-47.791v27.514q4.486-2.93 9.092-4.366 4.665-1.496 9.39-1.496 12.741 0 21.594 8.793 8.852 8.793 8.852 21.234 0 11.903-8.434 19.918-8.433 7.956-22.25 7.956-4.905 0-9.451-1.256t-8.793-3.709v2.99h-14.355q-4.427 0-6.34-1.674-1.855-1.734-1.855-4.486 0-2.692 1.914-4.366 1.914-1.735 6.28-1.735h2.094v-53.055h-2.093q-4.427 0-6.34-1.675-1.855-1.735-1.855-4.486 0-2.692 1.854-4.367 1.914-1.734 6.34-1.734zm36.666 52.038q0-7.596-5.323-12.86-5.324-5.264-13.04-5.264-7.656 0-12.98 5.264-5.323 5.264-5.323 12.68 0 6.76 4.785 11.126 4.785 4.307 13.518 4.307t13.518-4.307q4.845-4.366 4.845-10.946zm83.083 4.606h-50.304q1.914 4.785 6.759 7.716 4.905 2.93 13.219 2.93 6.819 0 18.123-2.93 4.666-1.196 6.46-1.196 2.453 0 4.128 1.734 1.674 1.735 1.674 4.367 0 2.392-1.794 4.067-2.393 2.213-11.664 4.247-9.271 1.974-17.825 1.974-14.714 0-23.566-8.314-8.793-8.315-8.793-20.457 0-12.92 9.51-20.995 9.57-8.135 22.012-8.135 7.477 0 13.698 2.632 6.28 2.632 9.33 5.683 4.307 4.426 7.119 10.946 1.914 4.546 1.914 10.527zm-13.578-12.262q-2.812-5.264-7.357-7.836-4.546-2.632-10.827-2.632-6.22 0-10.766 2.632-4.546 2.572-7.417 7.836zm53.294-8.853v24.584q0 3.948 1.615 5.204 2.513 1.974 8.973 1.974 9.39 0 17.346-4.008 3.05-1.555 4.785-1.555 2.393 0 4.127 1.795 1.795 1.794 1.795 4.366 0 2.393-1.914 4.127-2.931 2.811-11.604 5.204-8.614 2.333-14.535 2.333-11.425 0-17.167-4.905-5.683-4.965-5.683-12.142v-26.977h-4.426q-4.426 0-6.34-1.674-1.854-1.735-1.854-4.487 0-2.691 1.854-4.366 1.914-1.735 6.34-1.735h4.426v-11.065q0-4.427 1.675-6.28 1.735-1.915 4.486-1.915 2.692 0 4.367 1.914 1.734 1.854 1.734 6.28v11.066h22.67q4.426 0 6.28 1.735 1.915 1.675 1.915 4.426 0 2.692-1.914 4.427-1.855 1.674-6.28 1.674zm87.569 42.05v-2.871q-4.606 2.452-10.169 3.649-5.562 1.256-10.108 1.256-9.87 0-16.03-5.204-6.161-5.264-6.161-11.604 0-7.716 7.835-14.296 7.896-6.64 21.773-6.64 5.562 0 12.86 1.197v-2.93q0-2.752-2.393-4.487-2.332-1.735-8.972-1.735-5.443 0-14.116 2.154-3.23.777-5.024.777-2.453 0-4.187-1.734-1.675-1.795-1.675-4.546 0-1.555.598-2.692.598-1.136 1.675-1.794 1.076-.718 4.486-1.675 4.546-1.256 9.27-1.974 4.726-.778 8.554-.778 11.425 0 17.706 4.965 6.34 4.905 6.34 13.458v25.242h2.093q4.427 0 6.28 1.735 1.915 1.674 1.915 4.426 0 2.692-1.914 4.426-1.854 1.675-6.28 1.675zm0-21.952q-7.357-1.436-13.578-1.436-7.477 0-12.86 3.65-3.35 2.332-3.35 4.725 0 1.734 1.615 2.81 2.991 1.975 8.195 1.975 4.426 0 9.989-1.735 5.622-1.735 9.989-4.725zm67.71-7.836q0 10.468-3.47 21.234-2.571 7.896-7.955 17.526-3.888 6.939-5.742 8.554-1.854 1.615-4.127 1.615-2.632 0-4.426-1.795-1.795-1.794-1.795-4.307 0-1.794 1.436-4.127 6.46-10.587 9.39-19.858 2.991-9.271 2.991-18.842 0-9.51-2.99-18.781-2.931-9.272-9.391-19.859-1.436-2.392-1.436-4.127 0-2.512 1.795-4.307 1.794-1.794 4.426-1.794 2.213 0 3.888 1.435 2.392 2.034 6.34 9.391 5.682 10.588 7.776 17.406 3.29 10.588 3.29 20.636z"
    })]
  }));
};

Logo.defaultProps = {
  width: "150",
  height: "80",
  viewBox: "0 0 1920 1050",
  fill: "#FCFCFC",
  xmlns: "http://www.w3.org/2000/svg"
};









var LoginForm = function LoginForm(_ref) {
  var router = _ref.router,
      redirectURL = _ref.redirectURL;

  var _useState = (0,react.useState)(false),
      loginInProgress = _useState[0],
      setLoginInProgress = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loginError = _useState2[0],
      setLoginError = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      errorMessage = _useState3[0],
      setErrorMessage = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      emailError = _useState4[0],
      setEmailError = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      email = _useState5[0],
      setEmail = _useState5[1];

  var _useState6 = (0,react.useState)(""),
      password = _useState6[0],
      setPassword = _useState6[1];

  var _useAuthContext = (0,AuthContext/* useAuthContext */.E)(),
      signIn = _useAuthContext.signIn,
      user = _useAuthContext.user;

  var _useState7 = (0,react.useState)(null),
      pendingRedirect = _useState7[0],
      setPendingRedirect = _useState7[1];

  (0,react.useEffect)(function () {
    if (pendingRedirect && user) {
      router.push(pendingRedirect);
    }
  }, [pendingRedirect, user]);
  var loginData = {
    email: ""
  };

  var handleLogin = function handleLogin() {
    if (!(0,regex/* emailValidation */.D6)(email)) {
      setEmailError(true);
      setLoginError(true);
      setErrorMessage("Oops! Your email appears to be in the wrong format.");
      return;
    } else {
      setLoginInProgress(true);
      loginData = {
        email: email,
        password: password
      };
      signIn(loginData).then( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(response) {
          var _response$data$user;

          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (response.data) {
                    if (redirectURL) {
                      setPendingRedirect(redirectURL);
                    } else if (((_response$data$user = response.data.user) === null || _response$data$user === void 0 ? void 0 : _response$data$user.roles[0]) === "User") {
                      setPendingRedirect("/profile");
                    } else {
                      setPendingRedirect("/");
                    }
                  } else {
                    if (typeof response.error === "string") {
                      setErrorMessage(response.error);
                    } else {
                      setErrorMessage((0,string_utils/* extractErrorMessageFromProblemDetails */.RR)(response.error));
                    }

                    setLoginError(true);
                    setLoginInProgress(false);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  };

  var handleForgotPassword = function handleForgotPassword() {
    router.push("/reset-password");
  };

  var isSubmitButtonDisabled = function isSubmitButtonDisabled() {
    return Boolean(!email || !password);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* BasicInfoContainer */.j3, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* ImageContainer */.mo, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* Title */.Dx, {
      children: "Welcome Back!"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* FieldsContainer */.LA, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
        "aria-label": "Email Address",
        "data-cy": "login-email",
        type: "email",
        id: "email",
        placeholder: "Email",
        size: "lg",
        autoComplete: "username",
        value: email,
        error: emailError,
        disabled: loginInProgress,
        fullWidth: true,
        autoFocus: true,
        onChange: function onChange(event) {
          setEmail(event.target.value);

          if (emailError) {
            if (!(0,regex/* emailValidation */.D6)(event.target.value)) {
              setEmailError(true);
            } else {
              setEmailError(false);
              setLoginError(false);
            }
          }
        },
        InputProps: {
          spellCheck: "false",
          autoCapitalize: "none"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* TextField */.nv, {
        "aria-label": "Password",
        "data-cy": "login-password",
        id: "password",
        type: "password",
        size: "lg",
        placeholder: "Password",
        autoComplete: "current-password",
        value: password,
        disabled: loginInProgress,
        fullWidth: true,
        onChange: function onChange(event) {
          setPassword(event.target.value);
        },
        InputProps: {
          spellCheck: "false",
          autoCapitalize: "none"
        }
      }), loginError && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* InfoMessage */.$J, {
        variant: "error",
        hasBackground: true,
        message: errorMessage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* ForgottenPasswordLink */.XX, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* StyledLink */.Fg, {
          href: "/reset-password",
          children: "Forgotten Password"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Register_styles/* CTAForthContainer */.Uh, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* CustomSubmitButton */.Yf, {
        "data-cy": "login-button",
        disabled: isSubmitButtonDisabled(),
        disabledStateStyling: "lowOpacity",
        loading: loginInProgress,
        onClick: function onClick() {
          return handleLogin();
        },
        full: true,
        children: "Login"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BasicInfo_styles/* AlreadyMemberButton */.Oc, {
      children: ["Not a Member Yet?", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(BasicInfo_styles/* StyledLink */.Fg, {
        href: "/register",
        children: "Sign Up"
      })]
    })]
  });
};

LoginForm.displayName = "LoginForm";
var ComponentWithRouter = (0,next_router.withRouter)(LoginForm);

;// CONCATENATED MODULE: ./src/components/Login/index.ts

;// CONCATENATED MODULE: ./src/pages/Login/Login.tsx


var _excluded = ["router"];

function Login_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Login_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Login_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Login_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Login = function Login(_ref) {
  var router = _ref.router,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var query = router.query;
  var redirectURLParam = query.redirectUrl;
  var redirectURL = typeof redirectURLParam === 'string' ? redirectURLParam : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showMenu: true,
      showLoginButton: false
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Login_styles/* LoginContainer */.H, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Login_styles/* LoginOrRegisterContainer */.i, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentWithRouter, Login_objectSpread({
          redirectURL: redirectURL
        }, rest))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* MeshGradient */.bL, {
        sx: {
          position: 'fixed'
        },
        colour: "teal-green",
        position: "bottom",
        size: "low"
      })]
    })]
  });
};

/* harmony default export */ var Login_Login = ((0,next_router.withRouter)(Login));
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/CustomThemeProvider.tsx + 2 modules
var CustomThemeProvider = __webpack_require__(75044);
;// CONCATENATED MODULE: ./pages/login.tsx











var LoginPage = function LoginPage() {
  var theme = (0,useTheme/* default */.Z)();
  var seoTitle = "Login | That's The Ticket";
  var router = (0,next_router.useRouter)();

  var _useColorModeContext = (0,CustomThemeProvider/* useColorModeContext */.XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("dark");

  var getRedirectUrl = function getRedirectUrl() {
    var redirectURL = router.query.redirectURL;

    if (redirectURL) {
      window.localStorage.setItem("redirectURL", redirectURL.toString());
    }
  };

  (0,react.useEffect)(function () {
    getRedirectUrl();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "".concat(seoTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: seoTitle
      }, "ogTitle"), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: seoTitle
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Login_Login, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var login = ((0,next_router.withRouter)(LoginPage));

/***/ }),

/***/ 91001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function Footer() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    sx: {
      color: "#ffffff",
      margin: "5rem 0 2rem"
    },
    variant: "body2",
    color: "text.secondary",
    align: "center",
    children: ['Copyright © ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      color: "inherit",
      href: "#",
      children: "That's The Ticket"
    }), ' ', new Date().getFullYear(), "."]
  });
}

/***/ }),

/***/ 49617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ LoginContainer; },
/* harmony export */   "i": function() { return /* binding */ LoginOrRegisterContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);

var LoginContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    marginTop: theme.space._1000,
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,
    paddingBottom: "12.5rem"
  };
});
var LoginOrRegisterContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
    width: "min-content",
    alignSelf: "stretch",
    "@media (max-width: 600px)": {
      padding: "0 ".concat(theme.space._400),
      width: "100%"
    }
  };
});

/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "K0": function() { return /* binding */ RegisterContainer; },
/* harmony export */   "Uh": function() { return /* binding */ CTAForthContainer; },
/* harmony export */   "aN": function() { return /* binding */ ButtonLabel; },
/* harmony export */   "gj": function() { return /* binding */ StyledBlueSpan; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; },
/* harmony export */   "uF": function() { return /* binding */ CTABackAndForthContainer; },
/* harmony export */   "wW": function() { return /* binding */ RegisterStepsContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46409);



var RegisterContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    marginTop: theme.space._1000,
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._700,
    paddingBottom: "12.5rem"
  };
});
var StyledBlueSpan = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.colors["blue.400"]
  };
});
var RegisterStepsContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._600,
    width: "min-content",
    alignSelf: "strech",
    "@media (max-width: 600px)": {
      padding: "0 ".concat(theme.space._400),
      width: "100%"
    }
  };
});
var CTABackAndForthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch"
  };
});
var CTAForthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "stretch"
  };
});
var ButtonContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div")(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: "flex",
    paddingTop: theme.space._100,
    justifyContent: "center",
    alignItems: "center"
  };
});
var ButtonLabel = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function (_ref7) {
  var theme = _ref7.theme;
  return {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.md,
    fontStyle: 'normal',
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights["short"]
  };
});
var ButtonIcon = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_icons__WEBPACK_IMPORTED_MODULE_0__/* .Icon */ .J)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    width: theme.space._450,
    height: theme.space._450
  };
});

/***/ }),

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(64358);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);